import { Button } from "@/components/ui/button";

// DriveDesk AI — role-based quick-reply chips shown on an empty
// conversation, so users have zero-click access to their most common
// questions (per the "reduce clicks / reduce unnecessary thinking"
// product philosophy).
export const AISuggestedPrompts = ({ prompts, onPick, disabled }) => {
  if (!prompts || prompts.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="ai-suggested-prompts">
      {prompts.map((p) => (
        <Button
          key={p}
          type="button"
          variant="outline"
          size="sm"
          className="h-auto py-1.5 px-3 text-xs whitespace-normal text-left rounded-full"
          disabled={disabled}
          onClick={() => onPick(p)}
          data-testid="ai-suggested-prompt-chip"
        >
          {p}
        </Button>
      ))}
    </div>
  );
};
